<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs  >
        <!-- 过滤策略 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("logs.regional_authority") }}</span>
          <div class="main" v-if="this.table_role_show == 1">
            <p >
              <el-button
                @click="add_role_show()"
                
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.regional_authority1") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table_hover" v-if="this.table_role_show == 1" >
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
               
                class="table-fixed"
                v-loading="loading"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60">
                </el-table-column>
                <!-- 区域名称 -->
                <el-table-column
                  prop="AREA"
                  :label="this.area_text"
                 
                >
                </el-table-column>
                <!-- 备注说明-->

                <el-table-column
                  prop="DESCRIPTION"
                  :label="$t('logs.Policy_list7')"
                  width="110"
                >
                </el-table-column>
               
              
             
           
                <!-- 保存时间-->

                <el-table-column prop="SHOW_SAVE_DAYS" :label="$t('logs.Policy_list22')"  width="130">
                </el-table-column>
                 <el-table-column
                  prop=""
                  :label="$t('table1.operation')"
                  width="180"
                >
                  <template slot-scope="scope">
                  <!-- 删除-->
                        <el-button
                          @click="handleClick_reb_group(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ $t("table1.delete") }}
                        </el-button>
                        <!-- 编辑-->
                        <el-button
                          @click="handleClick2_group(scope.$index, scope.row)"
                          type="text"
                          size="small"
                          :disabled="$root.jurisdiction.only_query == 0"
                        >
                          {{ $t("table1.ditt") }}
                        </el-button>
                   
           
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加 和编辑部分-->
            <div class="lie lie_add_role" v-if="this.table_role_add == 1">
              <div class="create_information" v-if="this.table_role_edit == 0">
                {{ $t("logs.Policy_list2") }}
              </div>
              <div class="create_information" v-if="this.table_role_edit == 1">
                {{ $t("logs.Policy_list17") }}
              </div>

              <div class="find">
              
          
                    <!-- 区域名称 -->

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">

                   {{this.area_text}} :
                  </div>
                  <div class="block block1">
                     <p
                      v-if="this.table_role_edit == 1"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.area }}
                    </p>
                    <el-input v-model="area " placeholder=""   v-if="this.table_role_edit == 0"></el-input>
                  </div>
                </div>
            
                    <!-- 备注说明 -->

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">

                    {{ $t("logs.Policy_unit5") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="description" placeholder=""></el-input>
                  </div>
                </div>
            <!-- 保存时间 -->

                <div class="find1" >
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_list22") }}:
                  </div>
                  <div class="block block1">
                    <el-radio v-model="radio_saveday" label="0">{{
                      $t("logs.group7_a9")
                    }}</el-radio>
                    <el-radio
                      v-model="radio_saveday"
                      label="1"
                      style="margin-right: 10px"
                    >
                      {{ $t("logs.Policy_list23") }}</el-radio
                    >
                    <el-input
                      v-model="save_days"
                      placeholder=""
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      clearable
                      maxlength="5"
                      style="width: 100px"
                    ></el-input>
                  </div>
                </div>
                <!-- 策略权限 -->
                <div class="find1" >
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.strategy_group_admin_control") }} :
                  </div>
                  <div class="block block1" >
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      style="padding: 6px 0"
                      >{{ $t("logs.report13") }}</el-checkbox
                    >

                    <el-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
                      style="display: flex; flex-wrap: wrap; padding-bottom: 6px"
                    >
                      <el-checkbox
                        v-for="v in policy_priv_add_edit"
                        :label="v.key"
                        :key="v.key"
                        class="policy_priv_role"
                        >{{ v.label }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
                 <div class="find1">
                  <div class="find-text" style="padding-right: 12px"></div>
                  <div class="block block1">
                    <el-button type="primary" @click="save_polic_group()">{{
                      $t("tab.save")
                    }}</el-button>

                    <el-button type="danger" @click="off_policy_group()">{{
                      $t("tab.cancel")
                    }}</el-button>
                  </div>
                </div>
             </div>
             </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    
     
    
    </div>
  </div>
</template>

<script>


export default {

  data() {
    return {
     loading:false,
     fileList:[],
     area:'',
     area_text:'',
     description:"",
     priv_json_str:[],
     newadd:0,
     save_days:'',
        policy_priv_show: 0,
      table_role_show: 1,
      table_role_add: 0,
      table_role_edit: 0,
      xian1:true,
      isIndeterminate:false,
      checkAll:[],
      checkedCities:[],
     radio_saveday:'0',
      save_day: "",
        policy_priv_add_edit: [],
        dafa_check:[],
    };
  },

  mounted() {
    this.getFileList_regional();
    
  },
 methods: {
       handleCheckedCitiesChange(value) {
      console.log(value);
      
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.policy_priv_add_edit.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.policy_priv_add_edit.length;
      
    },
      handleCheckAllChange(val) {
      console.log(val);
      this.checkedCities = val ? this.policy_priv_add_edit.map((ele) => ele.key) : [];
       this.isIndeterminate = false;
      // this.isArr_priv();
    },
      // 显示

    add_role_show: function () {
     
        this.xian1=false
      this.newadd_fiter = 1;
      this.table_role_show = 0;
      this.table_role_edit = 0;
      this.table_role_add = 1;
      this.area="";
      this.description="";
      this.checkedCities=this.dafa_check;
      this.save_days='';
      this.radio_saveday='0'
   console.log(this.checkedCities,this.policy_priv_add_edit)
      this.checkAll = this.checkedCities.length==this.policy_priv_add_edit.length?true:false;
      this.isIndeterminate = this.checkedCities.length==this.policy_priv_add_edit.length?false:true;
     
  
    },
 // 过滤策略取消
    off_policy_group() {
      this.table_role_add = 0;
      this.table_role_show = 1;
    },
    // 过滤策略加载
    getFileList_regional() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_spam_area",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);
          this.loading = false;

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
           
            this.area_text = res.data.ret.spam_area_name;
            this.policy_priv_add_edit = res.data.ret.q_policy_priv;
            this.dafa_check=res.data.ret.init_policy_priv;

            this.fileList = res.data.ret.datalist;
          }
        });
    },
    save_polic_group() {
      // this.loading = true;
this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      // let multis_obj = [];
      // for (let i = 0; i < this.tableData_obj.length; i++) {
      //   multis_obj.push(this.tableData_obj[i].label);
      // }
      // let multis_obj1 = JSON.stringify(multis_obj);
      // let multis_list = [];
      // for (let v = 0; v < this.tableData_list.length; v++) {
      //   multis_list.push(this.tableData_list[v].label);
      // }
      // let multis_list1 = JSON.stringify(multis_list);
      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_spam_area",
        sid: sid,
      area:this.area,
      priv_json_str:JSON.stringify(this.checkedCities),
        description: this.description,
        newadd: this.newadd_fiter,
        save_day: this.radio_saveday == 0 ? 0 : this.save_days,
         

      });
      //  console.log(str)
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          this.$close_hint_test();
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList_regional();
            this.table_role_add = 0;
            this.table_role_show = 1;
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },

    // 过滤策略 编辑
    handleClick2_group(index, scope) {
     

      console.log(index, scope);

      this.table_role_add = 1;
      this.newadd_fiter = 0;
      this.table_role_edit = 1;
      this.table_role_show = 0;
    this.area=scope.AREA;
    if (scope.PRIV_JSON_STR) {
        this.checkedCities = JSON.parse(scope.PRIV_JSON_STR);
        // console.log(this.checkedCities,this.policy_priv_add_edit.length);

       
        
        console.log(this.checkAll)
       
      } else {
        this.checkedCities = [];
      }
          this.isIndeterminate =
        this.checkedCities.length > 0 &&   this.checkedCities.length < this.policy_priv_add_edit.length;
          this.checkAll =  this.checkedCities.length === this.policy_priv_add_edit.length;
      this.priv_json_str=scope.PRIV_JSON_STR
      this.description = scope.DESCRIPTION;
      this.save_days= scope.SAVE_DAYS==0?'':scope.SAVE_DAYS;
      this.radio_saveday= this.save_days==0? '0':'1';
      console.log(  this.radio_saveday)
    },
    // 过滤策略删除
    handleClick_reb_group(index, scope) {
      console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let policy_name = scope.AREA;
          let str = this.$qs.stringify({
            __mode: "del_spam_area",
            sid: sid,
            area: policy_name,
          });
          this.$axios.post("/api/adm/cgi/elkspam.cgi", str).then((res) => {
            // console.log(res);
              this.loading = false;

            if (!res) {
              console.log(1)
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
          
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
             
              this.getFileList_regional();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
 }
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
@import "../../css/lie_add_role.less";

/deep/ .has-gutter th {
  text-align: center;
}

/deep/ .has-gutter th:nth-child(2) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(3) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(4) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(5) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(16) {
  text-align: center;
}

/deep/ .el-table th {
  text-align: center;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: center;
}

/deep/ .el-table__row td:nth-child(2) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(3) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(4) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(5) {
  text-align: left;
}
/deep/ .el-table__row td:nth-child(6) {
  text-align: left;
}
/deep/ .el-table__row td:last-child {
  text-align: left;
}

/deep/ .el-tabs__nav {
  padding-left: 14px;
}

.pop-up1 {
  position: fixed;
  // padding: 20px 0;
  width: 44%;
  // height: 68%;
  top: 5%;
  left: 30%;
  z-index: 101;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  background: white;

  border-radius: 4px;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}
.pop-up1 .find1 {
  line-height: 30px;
}
.pop-up1 .find /deep/.el-input__inner {
  height: 24px !important;
  line-height: 24px !important;
}
.pop-up .el-radio-group {
  line-height: 30px;
  height: 30px;
}
.el-date-editor {
  margin-left: 10px;

  /deep/ .el-input__inner {
    padding-left: 30px;
  }
}

.tiaojian_a {
  border: 1px solid #ddd;
  padding: 0 10px !important;
}

.tiaojian_a ul {
  display: flex;
  align-items: center;

  font-size: 12px;
  border-bottom: 1px solid #ddd;

  li {
    padding: 0 10px;
  }
}

.tiaojian_a ol {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  .content_keyword_fang {
    display: flex;
    align-items: center;
  }
  li:nth-child(4) {
    padding-left: 10px;
  }

  li {
    padding-right: 10px;
  }

  /deep/.el-input {
    font-size: 12px;
  }
}
.tiaojian_a .tiaojian_a_child {
  .el-checkbox {
    margin-right: 0px;
  }
  .el-checkbox-group {
    width: 100%;
    margin: 2px 0;
  }
  .policy_priv_role {
    width: 15%;
  }
  flex-direction: column;
  align-items: flex-start;
  .content_keyword_fang {
    margin-bottom: 0px;
  }
  .content_keyword_fang_select {
    margin: 0;
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
}

/deep/ .el-radio__label {
  font-size: 12px;
}

// /deep/ .el-select {
//   display: flex;
//   justify-content: center;
// }

// 添加
.add1 {
  display: flex;
  align-items: center;
  font-size: 12px;
}

// 单选框
.check1 {
  margin: 0 10px;
}

.backText2 {
  margin-left: 40px;
}

.backText3 {
  margin-left: 30px;
}

.back1 .input5-1 {
  width: 100px;
}

.lie tbody td:nth-child(2) {
  display: flex;
  border-left: 1px solid #ddd;

  flex-direction: column;

  .el-input {
    width: 200px;
  }

  padding-left: 20px;

  div {
    padding: 2px 4px;
    margin: 5px 0;
  }
}

.alinkList_style {
  padding: 8px 0;
}

/deep/ .el-checkbox {
  display: flex;
  align-items: center;
  // line-height: 36px;
}

.ruel_find .find {
  width: 100%;
}

.ruel_find .block {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ruel_find_text {
  margin-right: 8px;
  color: #0e2c5e;
  width: 120px;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.ruel_find {
  /deep/ .el-button {
    padding: 8px 16px;
    // margin-left: 10px;
    font-size: 12px;
    // background: #eceff4;
    margin-top: 14px;
    margin-right: 10px;
  }

  .el-button--primary {
    background: #006be7;
  }

  .el-button--danger {
    background: #f05f5f;
  }
}

.el-select__input {
  vertical-align: baseline;
}
// /deep/ .sent2 .cell {
//     color: #f00 !important;
// }
.table-fixed .cell img {
  width: 16px;
  height: 16px;
}
// /deep/ .el-table__body tr:hover {
//   cursor: pointer;
// }
/deep/ .table_hover tr td:nth-child(3) :hover {
  cursor: pointer;
}
/deep/ .table_hover tr td:nth-child(4) :hover {
  cursor: pointer;
}
.cursor_hover:hover {
  cursor: pointer;
}
.find-text {
  width: 170px;
}
/deep/ .block{
  width: 66%;
}
// /deep/ .el-table .cell{
//    padding: 8px 0px 8px 2px;
// }
/deep/ .el-input--suffix {
  line-height: 42px;
}
.notice_the_template_warp {
  padding-left: 0;
  // width: 100%;
  flex: 1;
}
.notice_the_template {
  display: flex;
  align-items: center;
  box-shadow: 0px -1px 0px 0px #d2d7e6;
}
</style>
